import { Entity } from '@/modules/common/domain/entity'
import CompanyBranch from '@/modules/company/domain/companyBranch'

class MoneyBox extends Entity {
  name?: string
  currency?: string
  companyBranch: CompanyBranch | null
  amount?: number
  _icon?: string
  '@type': string

  constructor (data: any) {
    super(data, 'id', 'name')

    this.companyBranch = data.companyBranch == null ? null : new CompanyBranch(data.companyBranch)
  }
}

export default MoneyBox
